import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';

export const supportNotificationPreferencesStyles = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: 16,
		minWidth: 520,
	},
	subtitle: {
		color: THEME.colors.text.light,
		fontSize: 13,
	},
	grid: {
		display: 'grid',
		gridTemplateColumns: '1fr repeat(3, 84px)',
		alignItems: 'center',
		rowGap: 4,
	},
	columnHead: {
		color: THEME.colors.text.light,
		fontSize: 11,
		letterSpacing: '0.06em',
		textTransform: 'uppercase',
		paddingBottom: 8,
		borderBottom: `1px solid ${THEME.colors.border.light}`,
		marginBottom: 4,
	},
	columnHeadCentred: {
		textAlign: 'center',
	},
	inboxName: {
		fontSize: 14,
		paddingRight: 12,
		paddingTop: 6,
		paddingBottom: 6,
	},
	cell: {
		display: 'flex',
		justifyContent: 'center',
	},
	legend: {
		display: 'flex',
		flexDirection: 'column',
		gap: 4,
		paddingTop: 4,
		borderTop: `1px solid ${THEME.colors.border.light}`,
	},
	legendRow: {
		display: 'flex',
		gap: 8,
		alignItems: 'baseline',
	},
	legendTerm: {
		fontSize: 11,
		letterSpacing: '0.06em',
		textTransform: 'uppercase',
		color: THEME.colors.text.light,
		minWidth: 72,
	},
	hint: {
		color: THEME.colors.text.light,
		fontSize: 12,
	},
	notAgent: {
		color: THEME.colors.text.light,
		fontSize: 14,
	},
	loading: {
		display: 'flex',
		justifyContent: 'center',
		padding: 24,
	},
});
